import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';
import { WorkspaceNewService } from '@services/workspace-new.service'

@Directive({
  selector: '[disableWksChange]',
})
export class DisableWksChangeDirective {
  _workspaceSVC: WorkspaceNewService;
  _hostElement: ElementRef<any>;
  _renderer: Renderer2;

  constructor(private renderer: Renderer2, hostElement: ElementRef, workspaceService: WorkspaceNewService) {
    this._workspaceSVC = workspaceService;
    this._renderer = renderer;
    this._hostElement = hostElement;
  }
  @HostListener('mouseenter') onMouseEnter() {
    if (this._workspaceSVC.verifyIsDefaultWKS()) {
      this._renderer.addClass(this._hostElement.nativeElement, 'disable-wks-change');
    }
  }
}